module.exports = __webpack_public_path__ + "img/盖章@2x.4cb84633.png";